import { styled } from "linaria/react";

export const HeaderContainer = styled.div`
  grid-area: header;
  display: flex;
  gap: 1rem;
  align-items: center;
  flex-wrap: wrap;
`;
